var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7a5 5 0 1 1 10 0A5 5 0 0 1 2 7Zm12.295 8.7a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.43l-3.08-3.08a7.03 7.03 0 1 0-1.42 1.42l3.09 3.09Z"
  })));
};
export default SvgMagnifyingGlass;